import actions from "./actions";
import state from "./states"
import mutations from "./mutations";

const AdminCampaignModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default AdminCampaignModule;